module.exports = __webpack_public_path__ + "img/1-3.379c3348.jpg";